"use client";

import { useTranslations } from "next-intl";
import { css } from "styled-system/css";

import { useClaimableRewardsCount } from "@/contexts/queries/rewards/use-claimable-rewards-count";

export function RewardsCountBadge() {
  const t = useTranslations("navItems");
  const count = useClaimableRewardsCount();

  if (count === 0) return null;

  return (
    <span className={badgeStyles}>
      {count}
      <span className={css({ srOnly: true })}>{t("claimableRewardsBadge")}</span>
    </span>
  );
}

const badgeStyles = css({
  ml: "8",
  minW: "[18px]",
  h: "[18px]",
  px: "4",
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  rounded: "full",
  bg: "tag.background.gold",
  color: "tag.text.gold",
  fontSize: "11",
  lineHeight: "[1]",
  fontWeight: "medium",
  fontVariantNumeric: "tabular-nums",
  flexShrink: 0,
});
